import { render, staticRenderFns } from "./NewMonitoringPointForm.vue?vue&type=template&id=0d3e1556&scoped=true&"
import script from "./NewMonitoringPointForm.vue?vue&type=script&lang=js&"
export * from "./NewMonitoringPointForm.vue?vue&type=script&lang=js&"
import style0 from "./NewMonitoringPointForm.vue?vue&type=style&index=0&id=0d3e1556&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e1556",
  null
  
)

/* custom blocks */
import block0 from "./NewMonitoringPointForm.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3e1556')) {
      api.createRecord('0d3e1556', component.options)
    } else {
      api.reload('0d3e1556', component.options)
    }
    module.hot.accept("./NewMonitoringPointForm.vue?vue&type=template&id=0d3e1556&scoped=true&", function () {
      api.rerender('0d3e1556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/NewMonitoringPointForm.vue"
export default component.exports